module.exports = {"370305001":"闻韶街道","370305002":"雪宫街道","370305003":"辛店街道","370305004":"稷下街道","370305005":"齐陵街道","370305100":"齐都镇","370305102":"皇城镇","370305103":"敬仲镇","370305104":"朱台镇","370305107":"金岭镇","370305109":"凤凰镇","370305111":"金山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370305.json
// module id = 1273
// module chunks = 0